<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row p-3">
          <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
            <label>{{ $t('common_words.farm') }}: *</label>
            <br />
            <el-select
              id="farm_labor_catchs"
              clearable
              @change="showCalendar()"
              v-bind:collapse-tags="true"
              filterable
              class="select-primary custom-width-select required-farm shadow-sm"
              size="large"
              v-model="farm_sel"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-3 col-xl-3 mb-3">
            <label>{{ $t('common_words.date') }}: *</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              class="shadow-sm date-form required-date"
              v-model="date_sel"
              type="date"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="-"
              :placeholder="`${$t('common_words.select2')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-xl-3">
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.filter')
            }}</label
            ><br />
            <button
              class="btn btn-success custom-shadow-btn btn-filter"
              @click="validateDate"
            >
              {{ $t('common_words.generate') }}
            </button>
          </div>
        </div>
      </card>
      <div v-if="messageAlert" class="alert alert-warning" role="alert">
        {{ messageAlert.message }}
      </div>
      <card
        class="custom-shadow-card-header mt-4"
        :title="$t('sowing.reception')"
        v-if="showNurseryCatch && !messageAlert"
      >
        <div class="mt-4 px-3">
          <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
            <div class="table-responsive">
              <table
                class="table table-striped table-bordered not-last-td table-data"
              >
                <thead>
                  <tr class="cusmtom-thead-color">
                    <th scope="col" class="text-center p-3 custom-header-label">
                      <strong>*{{ $t('sowing.nurseries') }}</strong>
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      <strong>*{{ $t('common_words.crop_variety') }}</strong>
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      <strong
                        >*{{ $t('sowing.plants_seeds_recieved') }}</strong
                      >
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      <strong
                        >*{{ $t('sowing.plants_seeds_rejected') }}</strong
                      >
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      <strong>{{ $t('sowing.reason_rejection') }} </strong>
                    </th>
                    <th
                      v-if="!messageAlert"
                      scope="col"
                      class="text-center custom-header-label"
                      v-bind:style="{ width: '100px', marginTop: '6px' }"
                    >
                      <strong>{{ $t('common_words.options') }}</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="index in model.nNursereisCatch" :key="index">
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        style="min-width: 110px"
                        class="select-primary custom-width-select required-nursery shadow-sm"
                        size="large"
                        v-model="model.nurseries_ids[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, index) in nurseries"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        style="min-width: 110px"
                        class="select-primary custom-width-select required-cropsVarieties shadow-sm"
                        size="large"
                        v-model="model.crops_varieties_ids[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, index) in cropVarieties"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <fg-input
                        type="number"
                        min="1"
                        ref="plantsSeedsRecieved"
                        style="min-width: 90px"
                        class="shadow-sm text-center mt-3 required-plantsSeedsRecieved"
                        v-model.number="
                          model.quantity_plants_seeds_recieved[index - 1]
                        "
                        name="sowing.plants_seeds_recieved"
                        v-validate="
                          modelValidations.quantity_plants_seeds_recieved
                        "
                        :error="
                          getError('sowing.plants_seeds_recieved', true, index)
                        "
                      >
                      </fg-input>
                    </td>
                    <td class="text-center">
                      <fg-input
                        type="number"
                        min="1"
                        ref="plantsSeedsRejected"
                        style="min-width: 90px"
                        class="shadow-sm text-center mt-3 required-plantsSeedsRejected"
                        v-model.number="
                          model.quantity_plants_seeds_rejected[index - 1]
                        "
                        name="sowing.plants_seeds_rejected"
                        v-validate="
                          modelValidations.quantity_plants_seeds_rejected
                        "
                        :error="
                          getError('sowing.plants_seeds_rejected', true, index)
                        "
                        @change="
                          validateRejectedNumber(
                            model.quantity_plants_seeds_rejected[index - 1],
                            index - 1
                          )
                        "
                      >
                      </fg-input>
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        style="min-width: 110px"
                        class="select-primary custom-width-select required-reasonRejection shadow-sm"
                        size="large"
                        v-model="model.reason_rejection_ids[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, index) in reasonRejections"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </td>
                    <td
                      v-if="!messageAlert"
                      class="text-center"
                      style="min-width: 90px"
                    >
                      <div class="d-flex justify-content-center mt-3">
                        <a
                          v-if="isUpdate()"
                          v-tooltip.top-center="$t('common_words.add')"
                          class="btn-warning btn-simple btn-link custom-margin-actions"
                          @click.prevent="model.nNursereisCatch++"
                        >
                          <em class="fa fa-plus custom-size-fa-actions"></em>
                        </a>
                        <a
                          v-if="model.nNursereisCatch > 1 && isDelete()"
                          v-tooltip.top-center="$t('common_words.erase')"
                          class="btn-danger btn-simple btn-link custom-margin-actions"
                          @click="handleDelete(index - 1)"
                        >
                          <em class="fa fa-times custom-size-fa-actions"></em>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="!messageAlert" class="row">
            <div class="col-6 pr-0 text-right" v-if="isCreate() || isUpdate()">
              <button
                class="btn btn-success custom-shadow-btn btn-filter m-4"
                @click="validateEveryDetail()"
              >
                {{ $t('common_words.save') }}
              </button>
            </div>
            <div class="col-6 pl-0 text-left" v-if="isDelete()">
              <button
                class="btn btn-danger custom-shadow-btn btn-filter m-4"
                @click="confirmDelete"
              >
                {{ $t('common_words.delete') }}
              </button>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import i18n from 'src/i18n';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

export default {
  data() {
    return {
      farms: [],
      nurseries: [],
      cropVarieties: [],
      reasonRejections: [],
      messageAlert: null,
      showNurseryCatch: false,
      isShowCalendar: false,
      calendar_sel: null,
      farm_sel: null,
      date_sel: null,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      model: {
        id: null,
        nNursereisCatch: 1,
        farm_id: null,
        user_id: null,
        date_save: null,
        nurseries_ids: [],
        crops_varieties_ids: [],
        quantity_plants_seeds_recieved: [],
        quantity_plants_seeds_rejected: [],
        reason_rejection_ids: [],
        nursery_header_id: null,
        nursery_detail_ids: [],
        delete_nursery_header_id: null,
        delete_nursery_detail_ids: [],
      },
      modelValidations: {
        quantity_plants_seeds_recieved: {
          min_value: 1,
          numeric: true,
          required: true,
        },
        quantity_plants_seeds_rejected: {
          min_value: 0,
          numeric: true,
          required: true,
        },
      },
    };
  },
  mixins: [MixinMasters, MixinPermissions, MixinForm, MixinMenu],
  watch: {
    '$i18n.locale': 'forceRerender',
  },
  methods: {
    validateDate() {
      if (!isset(this.farm_sel)) return this.validationInputsRequired('farm');
      else if (this.date_sel == null)
        return this.validationInputsRequired('date');
      else if (this.calendar_sel == null)
        SweetAlert.warning(i18n.t('common_words.no_associated_calendars'));
      else {
        this.messageAlert = null;
        this.showNurseryCatch = true;
        this.cleanForm();
        this.loadData();
      }
    },
    showCalendar() {
      this.messageAlert = null;
      this.isShowCalendar = true;
      this.calendar_sel = null;
      this.showNurseryCatch = false;

      const element = Object.values(this.farms).find(
        (el) => el.id === this.farm_sel
      );
      if (element) {
        this.isShowCalendar = element.calendars.length > 1;
        this.calendar_sel =
          element.calendars.length > 1
            ? null
            : element.calendars.length == 1
            ? element.calendars[0].id
            : null;
      }
      this.isShowCalendar = false;
    },
    cleanForm() {
      if (this.messageAlert && !this.messageAlert.show)
        this.messageAlert = null;
      this.model.farm_id = null;
      this.model.date_save = null;
      this.model.user_id = null;
      this.model.nNursereisCatch = 1;
      this.model.nurseries_ids = [];
      this.model.crops_varieties_ids = [];
      this.model.quantity_plants_seeds_recieved = [];
      this.model.quantity_plants_seeds_rejected = [];
      this.model.reason_rejection_ids = [];
      this.model.nursery_header_id = null;
      this.model.nursery_detail_ids = [];
      this.model.delete_nursery_header_id = null;
      this.model.delete_nursery_detail_ids = [];
    },
    getDataRegisterForDelete(index) {
      const nurseryId = this.model.nurseries_ids[index];
      const cropVarietyId = this.model.crops_varieties_ids[index];

      const nurserySearch = this.nurseries.find(
        (nursery) => nursery.id === nurseryId
      );
      const cropVarietySearch = this.cropVarieties.find(
        (cropVariety) => cropVariety.id === cropVarietyId
      );
      return `${nurserySearch.name}-${cropVarietySearch.name}`;
    },
    setDeleteNurseryCatchs(index) {
      if (isset(this.model.nursery_detail_ids[index])) {
        this.model.delete_nursery_detail_ids.push(
          this.model.nursery_detail_ids[index]
        );
      }
    },
    registerSelectDelete(index) {
      this.setDeleteNurseryCatchs(index);
      this.model.nursery_detail_ids.splice(index, 1);
      this.model.nurseries_ids.splice(index, 1);
      this.model.crops_varieties_ids.splice(index, 1);
      this.model.quantity_plants_seeds_recieved.splice(index, 1);
      this.model.quantity_plants_seeds_rejected.splice(index, 1);
      this.model.reason_rejection_ids.splice(index, 1);
      this.model.nNursereisCatch--;
    },
    handleDelete(index) {
      if (
        isset(this.model.nurseries_ids[index]) &&
        isset(this.model.crops_varieties_ids[index])
      ) {
        SweetAlert.delete(this.getDataRegisterForDelete(index)).then(
          (result) => {
            if (result.value) {
              this.registerSelectDelete(index);
            }
          }
        );
      } else {
        this.registerSelectDelete(index);
      }
    },
    loadData() {
      this.showHideLoading(true);
      this.showNurseryCatch = true;
      let data = {
        farm_id: this.farm_sel,
        date_save: this.date_sel,
        user_id: this.$store.state.auth.user.id,
        route: 'nursery/nurserycatch/list',
      };
      Promise.all([Axios.postMasters(data)])
        .then((response) => {
          const nurseryCatchs = response[0].data.data;
          if (isset(nurseryCatchs)) {
            this.model.nursery_header_id = nurseryCatchs[0].id;
            this.model.farm_id = nurseryCatchs[0].farm_id;
            this.model.user_id = nurseryCatchs[0].user_id;
            this.model.date_save = nurseryCatchs[0].date_save;
            this.model.nNursereisCatch = 0;
            nurseryCatchs[0].nursery_details.forEach((nurseryDetail) => {
             this.model.nursery_detail_ids.push(nurseryDetail.id)
              this.model.nurseries_ids.push(nurseryDetail.nursery_id);
              this.model.crops_varieties_ids.push(
                nurseryDetail.crop_variety_id
              );
              this.model.quantity_plants_seeds_recieved.push(
                nurseryDetail.quantity_plants_seeds_recieved
              );
              this.model.quantity_plants_seeds_rejected.push(
                nurseryDetail.quantity_plants_seeds_rejected
              );
              this.model.reason_rejection_ids.push(
                nurseryDetail.reason_rejection_id
              );
              this.model.nNursereisCatch++;
            });
          }
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },
    validateEveryDetail() {
      for (let i = 0; i < this.model.nNursereisCatch; i++) {
        if (!isset(this.model.nurseries_ids[i]))
          return this.validationInputsRequired('nursery');
        else if (!isset(this.model.crops_varieties_ids[i]))
          return this.validationInputsRequired('cropsVarieties');
        else if (!isset(this.model.quantity_plants_seeds_recieved[i]))
          return this.validationInputsRequired('plantsSeedsRecieved');
        else if (!isset(this.model.quantity_plants_seeds_rejected[i]))
          return this.validationInputsRequired('plantsSeedsRejected');
        else if (!isset(this.model.reason_rejection_ids[i])) {
          if (this.model.quantity_plants_seeds_rejected[i] != 0) {
            SweetAlert.warning(i18n.t('sweet_alert.nursery.error_quantity_plants_seeds_rejected'));
            return false;
          }
        }
      }
      this.storeUpdateNurseryCatchs();
    },
    storeUpdateNurseryCatchs() {
      this.setDataByDefault();
      this.showHideLoading(true);
      if (this.isCreate() || this.isUpdate()) {
        this.model.route = 'nursery/nurserycatch/store';
        if (isset(this.model.nursery_header_id)) {
          this.model.route = 'nursery/nurserycatch/update';
          Axios.saveMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              SweetAlert.success(response.data.message).then(() => {
                this.showNurseryCatch = false;
                this.cleanForm();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
        } else {
          Axios.saveMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              SweetAlert.success(response.data.message).then(() => {
                this.showNurseryCatch = false;
                this.cleanForm();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
          this.showHideLoading();
        }
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },
    setDataByDefault() {
      this.model.farm_id = this.farm_sel;
      this.model.date_save = this.date_sel;
      this.model.user_id = this.$store.state.auth.user.id;
    },
    confirmDelete() {
      if (this.model.nursery_header_id) {
        SweetAlert.delete(
          i18n.t('sweet_alert.nursery.delete_nursery_catchs'),
          i18n.t('common_words.all_associated_records2')
        ).then((result) => {
          if (result.value) {
            this.deleteNurseryCatchs();
          }
        });
      } else this.cleanForm();
    },
    deleteNurseryCatchs() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.model.route = 'nursery/nurserycatch/delete';
        this.model.id = this.model.nursery_header_id;
        Axios.destroyMaster(this.model)
          .then((response) => {
            this.showNurseryCatch = false;
            this.cleanForm();
            this.showHideLoading();
            this.showNotification(
              i18n.t('show_notification.nursery.nursery_capture_deleted'),
              'success',
              'nc-simple-remove',
              `${i18n.t('common_words.successful_deletion')}...`
            );
          })
          .catch((error) => {
            this.showHideLoading();
            this.showMessageErrors(error);
          });
      } else {
        this.showMessageAccess();
      }
    },
    validateRejectedNumber(valueRejection, index) {
      if (valueRejection === 0) {
        this.model.reason_rejection_ids[index] = null;
      } 
    },
  },
  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('farms/farms/only'),
        Axios.getMasters('nursery/nursery'),
        Axios.getMasters('cropvarieties'),
        Axios.getMasters('nursery/reasonrejection'),
      ])
        .then(
          ([
            responseFarm,
            responseNursery,
            responseCropVariety,
            responseReasonRejection,
          ]) => {
            this.farms = responseFarm.data.data;
            this.nurseries = responseNursery.data.data;
            this.cropVarieties = responseCropVariety.data.data;
            let reasonRejections = responseReasonRejection.data.data;
            this.reasonRejections = reasonRejections.filter(
              (reasonRejection) => reasonRejection.type === 'Vivero'
            );

            this.showHideLoading();
          }
        )
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    } else {
      this.showHideLoading();
    }
  },
  mounted() {
    this.selectedItemOnMenu('nursery');
  },
  destroyed() {
    this.deselectedItemOnMenu('nursery');
  },
};
</script>
